import { adminEmails } from "utilities/constants/arcat-admin-emails";

const isEventEditable = (reduxState) => (
  adminEmails.includes(reduxState.user?.email) || 
  Object.keys(reduxState.eventData?.eventManagers || {}).includes(reduxState.user?.uid)
);

export default isEventEditable;
